import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Button, ButtonIcon } from '../button'
import { HStack } from '../hstack'
import { Text } from '../text'
import { type NavSectionProps } from './NavSection.types'

const addButtonClassName =
    'h-10 w-10 p-3 rounded border-2 border-solid border-action-default bg-transparent'

export function NavSection({
    title,
    onBack,
    backIcon,
    backLabel = 'Back',
    onAdd,
    addIcon,
    addLabel = 'Add',
    className,
}: NavSectionProps) {
    return (
        <HStack
            className={twMerge(
                'min-h-[76px] flex-row items-center justify-between gap-3 px-4 py-4',
                'bg-aos-bg-sub-surface border-b border-r border-border-subtle',
                className,
            )}
        >
            <HStack className='flex-row items-center gap-3'>
                {onBack && backIcon && (
                    <Button
                        accessibilityLabel={backLabel}
                        onPress={onBack}
                        className='h-6 w-6 p-0 bg-transparent'
                    >
                        <ButtonIcon as={backIcon} size={24} className='text-aos-text-default' />
                    </Button>
                )}
                <Text size='heading' weight='bold' tone='default'>
                    {title}
                </Text>
            </HStack>
            {onAdd && addIcon && (
                <Button
                    accessibilityLabel={addLabel}
                    onPress={onAdd}
                    className={addButtonClassName}
                >
                    <ButtonIcon as={addIcon} size={24} className='text-action-default' />
                </Button>
            )}
        </HStack>
    )
}
